import { spacing, typography } from '@/src/common/theme'
import { Text, View } from 'react-native'

export function FeedEmptyState() {
  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        padding: spacing['4'],
        gap: spacing['4'],
      }}
    >
      <Text style={typography['label/sm-regular']}>No Notifications</Text>
    </View>
  )
}
